import DefaultApiService from "./default";

const BASE = "SLN/SolarentOperator/ApplicantSms";

const pick = (obj, ...keys) => {
  if (!obj || typeof obj !== "object") return undefined;
  for (const key of keys) {
    if (obj[key] !== undefined && obj[key] !== null) return obj[key];
  }
  return undefined;
};

const unwrap = (res) => pick(res, "data", "Data") ?? null;
const isOk = (res) =>
  res != null && typeof res === "object" && (res.isSuccess === true || res.IsSuccess === true);
const messageOf = (res, fallback) =>
  pick(res, "message", "Message") || fallback || "خطا";

const toResult = (ok, data, message) => ({
  isSuccess: ok,
  message: message || null,
  data,
});

const ApplicantSmsApi = {
  getTemplates: async () => {
    const res = await DefaultApiService.getCustomeApi(`${BASE}/GetTemplates`);
    return toResult(isOk(res), unwrap(res) || [], messageOf(res));
  },

  resolveRecipients: async (payload) => {
    const res = await DefaultApiService.postApi(`${BASE}/ResolveRecipients`, payload || {});
    return toResult(isOk(res), unwrap(res), messageOf(res));
  },

  send: async (payload) => {
    const res = await DefaultApiService.postApi(`${BASE}/Send`, payload || {});
    return toResult(isOk(res), unwrap(res), messageOf(res));
  },

  getReport: async (payload) => {
    const res = await DefaultApiService.postApi(`${BASE}/GetReport`, payload || {});
    return toResult(isOk(res), unwrap(res), messageOf(res));
  },

  getSenders: async () => {
    const res = await DefaultApiService.getCustomeApi(`${BASE}/GetSenders`);
    return toResult(isOk(res), unwrap(res) || [], messageOf(res));
  },
};

export default ApplicantSmsApi;
